import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

// Public reply to a booking-site review that came through Channex.
export default function ReviewReply({ review }) {
  const [reply, setReply] = useState(review.reply || "");
  const [saved, setSaved] = useState(!!review.is_replied);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  if (saved) return (
    <div className="mt-2 pl-3 border-l-2 border-amber-300">
      <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-wide">Your reply</p>
      <p className="text-xs text-slate-600 dark:text-slate-300 whitespace-pre-wrap">{reply}</p>
    </div>
  );
  if (!open) return (
    <button onClick={() => setOpen(true)} className="mt-2 text-xs font-semibold text-amber-600 hover:text-amber-700">Reply publicly</button>
  );

  const send = async () => {
    if (!reply.trim() || busy) return;
    setBusy(true);
    try {
      await api.post(`/reviews/${review.id}/reply`, { reply: reply.trim() });
      setSaved(true);
      toast.success("Reply posted");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not post the reply");
    } finally { setBusy(false); }
  };
  return (
    <div className="mt-2 space-y-2">
      <textarea value={reply} onChange={e => setReply(e.target.value)} rows={3} maxLength={2000}
        placeholder="Thank the guest. This reply is public on the booking site."
        className="w-full text-xs px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200" />
      <div className="flex gap-2">
        <button onClick={send} disabled={busy || !reply.trim()}
          className="px-3 py-1.5 rounded-lg bg-amber-400 hover:bg-amber-500 text-white text-xs font-semibold disabled:opacity-50">
          {busy ? "Posting…" : "Post reply"}
        </button>
        <button onClick={() => setOpen(false)} className="px-3 py-1.5 text-xs text-slate-500">Cancel</button>
      </div>
    </div>
  );
}
